import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";

import { ReportsAPI } from "src/api";
import DatePicker from "src/components/structure/DatePicker";
import Card from "src/components/structure/Card";
import { error } from "src/components/structure/Alert";

import { AllUsersDisplay } from "./AllUsersDisplay";

import { BarGraph, IBarGraphDataPoint } from "src/components/structure/BarGraph";

interface IUserReportsProps {
  match: any;
  history: any;
  location: any;
}

interface IUserReportsState {
  loading: boolean;
  allUsersStats: any;
  start: moment.Moment;
  end: moment.Moment;
  allBySignupGraphData: any[];
}

class UserReports extends Component<IUserReportsProps, IUserReportsState> {
  constructor(props: IUserReportsProps) {
    super(props);

    this.state = {
      loading: true,
      start: moment().subtract(14, "days"),
      end: moment().add(1, "day"),
      allUsersStats: {},
      allBySignupGraphData: [],
    };

    this.fetchReports = this.fetchReports.bind(this);
    this.handleEndDateChanged = this.handleEndDateChanged.bind(this);
    this.handleStartDateChanged = this.handleStartDateChanged.bind(this);
  }

  componentDidMount() {
    this.fetchReports();
  }

  render() {
    return (
      <div className="row">
        <div className="col-12 col-lg-3">
          <AllUsersDisplay loading={this.state.loading} data={this.state.allUsersStats} />
        </div>
        <div className="col 12 col-lg-9">
          <div className="row">
            <div className="col-12">
              <Card title="">
                <div className="row">
                  <div className="col-4">
                    <label>From</label>
                    <DatePicker date={this.state.start} onDateSaved={this.handleStartDateChanged} />
                  </div>
                  <div className="col-4">
                    <label>To</label>
                    <DatePicker date={this.state.end} onDateSaved={this.handleEndDateChanged} />
                  </div>
                </div>
              </Card>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <Card title="User Registrations" loading={this.state.loading}>
                <BarGraph loading={this.state.loading} data={this.state.allBySignupGraphData} />
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private async fetchReports(){
    try{
      const reportsResult = await ReportsAPI.getAllUsers();
      this.setState({ allUsersStats: reportsResult.body.data, loading: false}, this.fetchGraphData);
    }catch(err){

    }
  }

  // this is broken out to handle date changes
  private fetchGraphData(){
    // just the devices by activation for now
    if(this.state.start.isAfter(this.state.end)){
      return error("Start must be after the end");
    }
    this.setState({ loading: true }, async () => {
      try{
        const allBySignupData = await ReportsAPI.getUsersBySignupDate(this.state.start.format("YYYY-MM-DD"), this.state.end.format("YYYY-MM-DD"));
        const allBySignupDataGraphData = this.convertToGraphFormat(allBySignupData.body.data);
        this.setState({ loading: false, allBySignupGraphData: allBySignupDataGraphData});
      }catch(err){
        this.setState({ loading: false});
      }
    })
  }

  private handleStartDateChanged(newDate: moment.Moment){
    this.setState({start: newDate}, this.fetchGraphData)
  }

  private handleEndDateChanged(newDate: moment.Moment){
    this.setState({end: newDate}, this.fetchGraphData)
  }

  private convertToGraphFormat(input: {date: string, count: number}[]): IBarGraphDataPoint[] {
    // 
    const parsed: IBarGraphDataPoint[] = [];
    for(const day of input){
      parsed.push({
        key: day.date, 
        count: day.count});
    }
    return parsed;
  }

}

const mapStateToProps = function map(s: any) {
  return {
    userState: s.userState,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserReports) as any
);
